<template>
  <div>
    <v-form ref="form" v-model="formValid">
      <div class="flex-row d-flex align-center mb-5">
        <div class="icon-wrapper">
          <v-icon small> mdi-currency-usd </v-icon>
        </div>
        <div class="title mx-5">
          {{ t("VOUS_SOUHAITEZ_EFFECTUER_UN") }} {{ donationTypeLabel }}
          {{ t("DE") }}
          <span class="font-weight-bold primary--text">{{ donationInfo.amount }}</span>
          {{ currency.unit }}.
        </div>
      </div>
      <div class="flex-row d-flex align-center mb-5">
        <div class="icon-wrapper">
          <v-icon small> mdi-account </v-icon>
        </div>
        <div class="d-flex flex-column body-1 mx-5">
          <span class="caption primary--text font-weight-bold">{{ t("VOS_RENSEIGNEMENTS_PERSONNELS") }}</span>
          <span>{{ civilityLabel }} {{ personalInfo.firstName }} {{ personalInfo.lastName }}</span>
          <span>{{ personalInfo.email }}</span>
          <span v-if="personalInfo.isCompany">{{ t("DE") }} : {{ personalInfo.companyName }}</span>
        </div>
      </div>
      <div class="flex-row d-flex align-center mb-5">
        <div class="icon-wrapper">
          <v-icon small> mdi-map-marker </v-icon>
        </div>
        <div class="d-flex flex-column body-1 mx-5">
          <span class="caption primary--text font-weight-bold">{{ t("VOS_COORDONNEES") }}</span>
          <span>{{ contactInfo.address || "-" }}</span>
          <span>{{ contactInfo.zipCode }} {{ contactInfo.city }}</span>
          <span>{{ provinceName }} {{ countryName }}</span>
          <span>{{ contactInfo.phone }}</span>
          <span>{{ contactInfo.mobile }}</span>
        </div>
      </div>
      <div>
        <h4 class="title primary--text mb-2">
          <v-icon small color="primary" class="mr-3"> mdi-comment </v-icon>
          {{ t("VOTRE_COMMENTAIRE") }}
        </h4>
        <v-textarea v-model="commentaire" counter maxlength="200" full-width rows="3" :outlined="isOutlined" :dense="isDense" :disabled="loading" />
      </div>

      <FormActionBar
        :cancel-label="t('RETOUR')"
        :valid-label="t('PAYER')"
        :can-validate="formValid"
        @cancel-click="goBack"
        @valid-click="processPayment"
        :disabled="loading"
        :loading="loading"
      />
    </v-form>

    <v-alert v-if="error" type="error" text class="ma-2">
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
import FormActionBar from "@/components/FormActionBar"
import { mapGetters } from "vuex"
import appMode from "@/mixins/appMode.js"
import paysafeModale from "@/mixins/paysafeModale.js"

export default {
  components: {
    FormActionBar
  },
  mixins: [paysafeModale, appMode],
  data() {
    return {
      error: "",
      commentaire: null,
      moyenDePaiement: undefined,
      formValid: true
    }
  },
  computed: {
    ...mapGetters([
      "campaignSlug",
      "contactInfo",
      "donationInfo",
      "personalInfo",
      "dedicaceInfo",
      "jeVeuxFaireUneDedicace",
      "donationTypes",
      "countries",
      "provinces",
      "civilities",
      "params",
      "formParams",
      "currency",
      "currencyCode",
      "paysafeLocale",
      "t",
      "currentLangId",
      "infosPaysafe",
      "isOutlined",
      "isDense"
    ]),
    donationTypeLabel() {
      let selectedDonationType = this.selectedDonationType
      if (selectedDonationType && selectedDonationType.type && selectedDonationType.type.name) {
        return selectedDonationType.type.name.toLowerCase()
      }
      return this.t("DON")
    },
    selectedDonationType() {
      if (this.donationTypes.length === 0 || !this.donationInfo || !this.donationInfo.type) {
        return null
      }
      const donationType = this.donationTypes.find((t) => t.type.id === this.donationInfo.type)
      return donationType
    },
    hasToChooseMoyenDePaiement() {
      let selectedDonationType = this.selectedDonationType
      if (selectedDonationType) {
        return selectedDonationType.moyensDePaiement.length > 0
      }
      return false
    },
    country() {
      if (!this.countries || !this.contactInfo.country) {
        return null
      }
      return this.countries.find((c) => c.id === this.contactInfo.country)
    },
    countryName() {
      if (!this.country) {
        return null
      }
      return this.country.name
    },
    countryCode() {
      if (!this.country) {
        return null
      }
      return this.country.code
    },
    provinceName() {
      if (!this.provinces || !this.contactInfo.province) {
        return null
      }
      let found = this.provinces.find((c) => c.id === this.contactInfo.province)
      if (found) {
        return found.name
      }
      return null
    },
    civilityLabel() {
      if (!this.civilities || !this.personalInfo.civility) {
        return null
      }
      return this.civilities.find((c) => c.id === this.personalInfo.civility).name
    },
    fullName() {
      return this.personalInfo.firstName + " " + this.personalInfo.lastName
    },
    estDAS() {
      return this.params.formParams.typeDeFormulaire === "DAS"
    }
  },
  methods: {
    processPayment() {
      this.$refs.form.validate()
      if (this.formValid) {
        if (this.estDAS) {
          this.postSasValidation()
        } else {
          this.paramsModale.billingAddress.street = this.contactInfo.address
          this.paramsModale.billingAddress.city = this.contactInfo.city
          this.paramsModale.billingAddress.zip = this.contactInfo.zipCode
          this.paramsModale.displayPaymentMethods = this.params.displayPaymentMethods.map((x) => x.code)
          this.paramsModale.preferredPaymentMethod = this.params.preferredPaymentMethod.code || this.paramsModale.preferredPaymentMethod
          this.showPaysafeModale(this.donationInfo.amount, this.fullName)
        }
      }
    },
    getPostSasValidationParams(token, paymentMethod) {
      const data = {
        ...this.contactInfo,
        ...this.personalInfo,
        ...this.donationInfo,
        jeVeuxFaireUneDedicace: this.jeVeuxFaireUneDedicace,
        sasDedicace: {
          ...this.dedicaceInfo
        },
        campaignSlug: this.campaignSlug,
        language: this.currentLangId,
        commentaire: this.commentaire,
        paymentMethod,
        token
      }

      return data
    },
    async postSasValidation(token, paymentMethod) {
      try {
        this.setLoading(true)
        const response = await this.$axios.api.post(`sas-validation`, this.getPostSasValidationParams(token, paymentMethod))
        this.setLoading(false)

        if (response.data.statutSas == "VALIDE") {
          this.setModeConfirmation()
        } else {
          this.setModeErreur()
          this.error = this.t("ERROR_DURING_PAYMENT")
        }
      } catch (error) {
        this.setLoading(false)
        this.setModeErreur()
        this.error = this.t("ERROR_DURING_PAYMENT")
        if (error.response) {
          console.log(error.response.data.ExceptionMessage)
        }
      }
    },
    onSuccessPaysafe(token, paymentMethod) {
      this.postSasValidation(token, paymentMethod)
    },
    goBack() {
      this.$emit("to-step", 3)
    }
  }
}
</script>

<style scoped>
.icon-wrapper {
  width: 20px;
}
</style>